import {
  CONFLUENCE,
  JIRA_CORE,
  JSD,
  TEAM_CENTRAL,
  BEACON,
  BITBUCKET
} from '../../../utility/constants';

export const getSocialProofProductLabel = (productKey: string) => {
  switch (productKey) {
    case 'jira-servicedesk.ondemand':
      return JSD;
    case 'confluence.ondemand':
      return CONFLUENCE;
    case 'jira-core.ondemand':
      return JIRA_CORE;
    case 'townsquare':
      return TEAM_CENTRAL;
    case 'beacon':
      return BEACON;
    case 'com.atlassian.bitbucket':
      return BITBUCKET;
    default:
      return '';
  }
};

export type FirstImpressionsProductImageUrls = {
  readonly heroImage: string;
  readonly socialProofImage?: string;
};

export type FirstImpressionsImageUrls = {
  readonly backgroundImage: string;
  readonly jiraSoftware: FirstImpressionsProductImageUrls;
  readonly jiraServiceDesk: FirstImpressionsProductImageUrls;
  readonly confluence: FirstImpressionsProductImageUrls;
  readonly jiraCore: FirstImpressionsProductImageUrls;
  readonly teamCentral: FirstImpressionsProductImageUrls;
  readonly beacon: FirstImpressionsProductImageUrls;
  readonly bitbucket: FirstImpressionsProductImageUrls;
};

export type GetSocialProofImageURLsOptions = {
  readonly productKey: string;
  readonly firstImpressionsImageUrls: FirstImpressionsImageUrls;
};

export const getSocialProofImageURLs = ({
  productKey,
  firstImpressionsImageUrls
}: GetSocialProofImageURLsOptions) => {
  switch (productKey) {
    case 'jira-servicedesk.ondemand':
      return {
        heroImage: firstImpressionsImageUrls.jiraServiceDesk.heroImage,
        logoImage: firstImpressionsImageUrls.jiraServiceDesk.socialProofImage
      };
    case 'confluence.ondemand':
      return {
        heroImage: firstImpressionsImageUrls.confluence.heroImage,
        logoImage: firstImpressionsImageUrls.confluence.socialProofImage
      };
    case 'jira-core.ondemand':
      return {
        heroImage: firstImpressionsImageUrls.jiraCore.heroImage,
        logoImage: firstImpressionsImageUrls.jiraCore.socialProofImage
      };
    case 'townsquare':
      return {
        heroImage: firstImpressionsImageUrls.teamCentral.heroImage,
        logoImage: firstImpressionsImageUrls.teamCentral.socialProofImage
      };
    case 'beacon':
      return {
        heroImage: firstImpressionsImageUrls.beacon.heroImage,
        logoImage: firstImpressionsImageUrls.beacon.socialProofImage
      };
    case 'com.atlassian.bitbucket':
      return {
        heroImage: firstImpressionsImageUrls.bitbucket.heroImage,
        logoImage: firstImpressionsImageUrls.bitbucket.socialProofImage
      };
    default:
      return {
        heroImage: firstImpressionsImageUrls.jiraSoftware.heroImage,
        logoImage: firstImpressionsImageUrls.jiraSoftware.socialProofImage
      };
  }
};
